import { atom } from "jotai";

import type {
  UserInfo,
  UserProfileSettings,
} from "@mirage/mosaics/UserProfilePage/types";

export const confettiTrackerAtom = atom<{
  [displayHandle: string]: boolean;
}>({});

// Set to undefined if loading, null if not found, UserInfo if found
export const userInfoMapAtom = atom<{
  [displayHandle: string]: UserInfo | null | undefined;
}>({});

export const userProfileSettingsAtom = atom<UserProfileSettings>({});
